import React, {Component} from 'react';
import {connect} from 'react-redux';

import BodyConditionHeadingOutput from '../../components/BodyConditionHeadingOutput/BodyConditionHeadingOutput';
import Loader from './../../components/Loader/Loader'

/**
 * Body Condition Heading container
 */
class BodyConditionHeading extends Component {
  render() {
    const {data, error, pending, ready} = this.props;
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-body-condition-heading__wrapper'>
        {error && <span className='nppe2-fc-body-condition-heading__error'>{error}</span>}
        {!error &&
        <BodyConditionHeadingOutput data={data} />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.bodyConditionReducer.error,
    data: state.bodyConditionReducer.data,
    pending: state.bodyConditionReducer.pending,
    ready: state.bodyConditionReducer.ready,
  }
};



export default connect(mapStateToProps)(BodyConditionHeading);
